"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _chartHelper = require("./chartHelper");

var AreaGradient = function AreaGradient(_ref) {
  var id = _ref.id,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("linearGradient", {
    key: id,
    id: id,
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "5%",
    stopColor: (0, _chartHelper.getColor)(color),
    stopOpacity: 0.8
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "95%",
    stopColor: (0, _chartHelper.getColor)(color),
    stopOpacity: 0
  }));
};

AreaGradient.defaultProps = {
  id: 'areaGradient',
  color: 'color-coldplay-fountain'
};
var _default = AreaGradient;
exports.default = _default;